import React, { useState } from "react";
import { Modal, Progress } from "flowbite-react";
import { TableUi } from "../components/table.ui";
import { EyeIcon, IdentificationIcon, LockClosedIcon, MailIcon, PencilAltIcon, PhoneIcon, TrashIcon, UserIcon } from "@heroicons/react/outline";
import { useMutation, useQuery } from "react-query";
import userServices from "../services/user.services";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
import {InputUi} from '../components/input.ui'
import { ButtonUi, LoadingUi } from "../components/components";
import { useNavigate } from "react-router";


export const User = () => {
  const _form = useForm({mode: 'all'});
  const navigate = useNavigate();


  const inputParams = [
    {
      label: 'Prenom',
      placeholder: 'doe',
      name: 'prenom',
      type: 'text',
      leftIcon: UserIcon,
      error: _form.formState.errors?.prenom?.message,
      validations: {
        required: 'prenom est réquis',
      },
      children:[
        {
          label: 'Nom',
          placeholder: 'jhon',
          name: 'nom',
          type: 'text',
          leftIcon: UserIcon,
          error: _form.formState.errors?.nom?.message,
          validations: {
            required: 'nom est réquis',
          }
        }
      ]
    },
    {
      label: 'Téléphone',
      placeholder: '621078833',
      name: 'phone',
      type: 'number',
      leftIcon: PhoneIcon,
      error: _form.formState.errors?.phone?.message,
      validations: {
        required: 'Téléphone est réquis',
      },
      children: [
        {
          label: 'Email',
          placeholder: 'example@domaine.com',
          name: 'email',
          type: 'email',
          leftIcon: MailIcon,
          error: _form.formState.errors?.email?.message,
          validations: {
            required: 'Email est réquis',
          }
        },
      ]
    },
    {
      label: 'Matricule',
      placeholder: 'ART01ABCDEFGH',
      name: 'matricule',
      type: 'text',
      autoComplete: 'matricule',
      leftIcon: IdentificationIcon,
      error: _form.formState.errors?.matricule?.message,
      validations: {
        required: 'Matricule est réquis',
      },
      children: [
        {
          label: 'Fonction',
          placeholder: 'ex: employé',
          name: 'fonction',
          type: 'text',
          autoComplete: 'fonction',
          leftIcon: UserIcon,
          error: _form.formState.errors?.fonction?.message,
          validations: {
            required: 'Fonction est réquise',
          },
        },
        {
          label: 'Mot de passe',
          placeholder: '*********',
          name: 'password',
          type: 'password',
          autoComplete: "current-password",
          leftIcon: LockClosedIcon,
          error: _form.formState.errors?.password?.message,
          validations: {
            required: 'Mot de passe est réquis',
            maxLength: { value: 20, message: 'Au maximum 20 caractères' },
            minLength: { value: 6, message: 'Au minimum 6 caractères' },
          },
        },
      ]
    }
  ]

  const [state, setState] = useState({
    showModal: false,
    type:'new',
    selectedUser:null,
  })
  const initState = () => setState({ 
    ...state, showModal:false, 
    selectedUser:null, type:'new' 
  })

  const _users = useQuery('users');
  const _userCreate = useMutation(userServices.create, {
    onSuccess: resp => {
      _users.refetch()
      _form.reset()
      toast.success('Menu ajouté avec succès')
    },
    onError: resp => {
        if(resp?.response?.data?.error){
          toast.error(resp?.response?.data?.error)
        } else
        toast.error("Une erreur inconnue s'est produite")
      },
      onSettled: () => initState()
  })
  const _userUpdate = useMutation(userServices.update, {
    onSuccess: resp => {
        _users.refetch()
        _form.reset()
        _userUpdate.reset()
        toast.success('Utilisateur modifié avec succès')
      },
      onError: resp => {
        if(resp?.response?.data?.error){
          toast.error(resp?.response?.data?.error)
        } else
        toast.error("Une erreur inconnue s'est produite")
      },
      onSettled: () => initState()
  })
  

  const _userDelete = useMutation(userServices.delete, {
    onSuccess: resp => {
      _users.refetch()
      toast.success('Utilisateur supprimé avec succès')
    },
    onError: resp => {
      if(resp?.response?.data?.error){
        toast.error(resp?.response?.data?.error)
      } else
      toast.error("Une erreur inconnue s'est produite")
    },
    onSettled: () => initState()
  })

  const _userResetCmd = useMutation(userServices.resetCommande, {
    onSuccess: resp => {
      _users.refetch()
      toast.success('Tableau de commandes réinitialisé avec succès')
    },
    onError: resp => {
      if(resp?.response?.data?.error){
        toast.error(resp?.response?.data?.error)
      } else
      toast.error("Une erreur inconnue s'est produite")
    },
    onSettled: () => initState()
  })

  const COLUMNS = [
    {
      Header: "##",
      accessor: "_id",
    },
    {
      Header: "Image",
      accessor: "image",
      Cell: ({ cell }) => (
        <div className="">
          <img
            className="w-14 h-14 rounded-full bg-gray-100"
            src='/assets/employe.png'
          />
        </div>
      ),
    },
    {
      Header: "Prenom",
      accessor: "prenom",
    },
    {
      Header: "Fonction",
      accessor: "fonction",
    },
    {
      Header: "Nom",
      accessor: "nom",
      Cell: ({cell}) => (
        <div className="flex justify-start">
          {cell.row.values.prenom.charAt(0).toUpperCase()+cell.row.values.prenom.slice(1)+' '+cell.row.values.nom}
        </div>
      )
    },
    {
      Header: "Téléphone",
      accessor: "telephone",
    },
    {
      Header: "Matricule",
      accessor: "matricule",
    },
    {
      Header: "Email",
      accessor: "email",
    },
    {
      Header: "Nombre commande",
      accessor: "mesCommandes",
      Cell: ({ cell }) => (
        <div>
          <div className="text-xs text-black flex items-end justify-end">
            {cell.row.values.mesCommandes.length}/22
          </div>
          <Progress progress={cell.row.values.mesCommandes.length} size="lg" />
        </div>
      ),
    },
    {
      Header: "Prix total",
      accessor: "mesCommandes",
      id:'prixTotal',
      Cell: ({ cell }) => {
        let prix = 0
        let cmd = cell.row.values.mesCommandes;
        for (let index = 0; index < cmd.length; index++) {
          prix += cmd[index]['prix']
        }
        return (
          <div className="bg-blue-500 p-1 rounded-full text-white">{prix} GNF </div>
        )
      }
      
    },
    {
      Header: "Action",
      Cell: ({ cell }) => (
        <div className="flex gap-3 justify-center">
          <div className="rounded-md shadow-md p-1" >
            <EyeIcon
              className="cursor-pointer text-gray-500 h-4 w-4"
              onClick={() => {
                navigate(`/dashboard/user/${cell.row.values._id}`)
              }}
            />
          </div>
          <div className="rounded-md shadow-md p-1" >
            <PencilAltIcon
              className=" cursor-pointer text-blue-500 h-4 w-4"
              onClick={() => {
                _userCreate.reset()
                _userUpdate.reset()
                _form.setValue('matricule', cell.row.values.matricule)
                _form.setValue('nom', cell.row.values.nom)
                _form.setValue('prenom', cell.row.values.prenom)
                _form.setValue('phone', cell.row.values.telephone)
                _form.setValue('email', cell.row.values.email)
                _form.setValue('fonction', cell.row.values.fonction)

                setState({
                  ...state,
                  showModal: !state.showModal,
                  error: null,
                  type: 'edit',
                  selectedUser: cell.row.values
                })
              }}
            />
          </div>
          <div className="rounded-md shadow-md p-1" >
            <TrashIcon
              className=" cursor-pointer text-red-500 h-4 w-4"
              onClick={() => {
                setState({
                  ...state,
                  showModal: !state.showModal,
                  error: null,
                  type: 'delete',
                  selectedUser: cell.row.values
                })
              }}
            />
          </div>
        </div>
      ),
    },
  ];

  const onSubmit = (r) => {
    setState({ ...state, error: null })
    let data = {
      nom: r.nom,
      prenom: r.prenom,
      matricule: r.matricule,
      telephone: r.phone,
      email: r.email,
      password: r.password,
      typeAccount: 'employe',
      fonction: r.fonction,
      id: state.selectedUser?._id,
    }

    if(state.type === 'new')
      _userCreate.mutate(data)
    if(state.type === 'edit')
      _userUpdate.mutate(data)

  }

  return (
    <div className="px-5 bg-white rounded-2xl">
      <div className="flex flex-col pt-2">
        <div className="flex flex-row text-center justify-between">
          <div className="flex flex-col text-left">
            <h1 className="text-xl ">Utilisateurs</h1>
            <p className="text-gray-400 text-xs">
              Nombre de commande effectuée par mois
            </p>
          </div>
          <button
            onClick={() => {
              setState({
                ...state,
                showModal: true,
                error: null,
                selectedUser: null,
                type: 'new'
              })
              _form.reset()
              _userCreate.reset()
              _userUpdate.reset()
            }
            }
            className="flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-primary focus:outline-none"
          >Ajouter un utilisateur</button>

          <React.Fragment>
            <Modal
              show={state.showModal}
              size={state.type === 'delete' ? 'sm' : '2xl'}
              onClose={() => initState()}>
              <Modal.Header>{
                state.type === 'new' 
                  ? 'Nouveau utilisateur' 
                  : state.type === 'delete'
                    ? 'Suppression'
                    : 'Description'
                }</Modal.Header>
              <Modal.Body className="space-y-6">
                <div>
                  {
                    state.type === 'delete'
                    ? <div>
                        <p className="text-gray-600 pb-5">Vous êtes sur le point de supprimer cet utilisateur, voulez-vous continuer?</p>
                        <div className="flex justify-between gap-10">
                          <button
                              onClick={() => initState()}
                              className="w-full flex justify-center py-2 mt-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-gray-800 bg-gray-400 focus:outline-none"
                          >Annuler</button>
                          <button
                            type="submit"
                            onClick={() => {
                              _userDelete.mutate(state.selectedUser?._id)
                            }}
                            className="w-full flex justify-center py-2 mt-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-red-600 focus:outline-none">
                            {
                              !_userDelete.isLoading ? 'Supprimer' : <LoadingUi />
                            }
                          </button>
                        </div>
                      </div>
                    : state.type === 'desc'
                    ? <div>
                      <div className="flex justify-between">
                        <p className=" font-medium">
                          {state.selectedUser?.prenom.charAt(0).toUpperCase()+state.selectedUser?.prenom.slice(1)+' '+state.selectedUser?.nom}
                        </p>
                        <p className="bg-blue-500 text-white px-3 py-1 rounded-full">{state.selectedUser?.matricule}</p>
                      </div>

                      <div className="flex gap-2 pt-3">
                        <div className="bg-green-400 p-1 rounded-full">
                          <PhoneIcon className="text-white h-5 w-5"/>
                        </div>
                        <div>
                          <p>Téléphone: {state.selectedUser?.telephone}</p>
                        </div>
                      </div>
                      <div className="flex gap-2 pt-3">
                        <div className="bg-red-400 p-1 rounded-full">
                          <MailIcon className="text-white h-5 w-5"/>
                        </div>
                        <div>
                          <p>Email: {state.selectedUser?.email}</p>
                        </div>
                      </div>
                      
                      <div className=" bg-white shadow-md w-full py-5 px-2 rounded-md">
                        <Progress
                          progress={state.selectedUser?.mesCommandes.length}
                          label="Commandes"
                          labelPosition="outside"
                          labelProgress={true}
                        />
                        <div className="flex justify-end">
                          {
                            state.selectedUser?.mesCommandes.length !== 0
                            ? <button
                              onClick={() => {
                                _userResetCmd.mutate({userId: state.selectedUser?._id})
                              }}
                              className="flex justify-center mt-3 px-3 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-red-500 focus:outline-none"
                            >{
                              !_userResetCmd.isLoading ? 'Réinitialiser' : <LoadingUi />
                            }</button>
                            : <button
                                onClick={() => {}}
                                className="flex justify-center mt-3 px-3 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-gray-500 focus:outline-none"
                              >Réinitialiser</button>
                          }
                        </div>
                      </div>
                    </div>
                    :<form onSubmit={_form.handleSubmit(onSubmit)}>
                      {
                        inputParams?.map(item => {
                          if(item.children.length === 1){
                            return (
                              <div key={item.name} className="grid grid-cols-2 gap-y-6 gap-x-4">
                                <div key={item.name}>
                                  <InputUi
                                    label={item.label}
                                    name={item.name}
                                    type={item.type}
                                    LeftIcon={item.leftIcon}
                                    placeholder={item.placeholder}
                                    register={_form.register}
                                    error={item.error}
                                    validations={item.validations}
                                    bg='gray-200'
                                    />
                                </div>
                                <div key={item.children[0].name}>
                                  <InputUi
                                    label={item.children[0].label}
                                    name={item.children[0].name}
                                    type={item.children[0].type}
                                    LeftIcon={item.children[0].leftIcon}
                                    placeholder={item.children[0].placeholder}
                                    register={_form.register}
                                    error={item.children[0].error}
                                    validations={item.children[0].validations}
                                    bg='gray-200'
                                    />
                                </div>
                              </div>
                            )
                          } 
                        })
                      }
                      {
                        inputParams[2].name === 'matricule' && (
                          <div key={inputParams[2].name} className="grid grid-cols-2 gap-y-6 gap-x-4">
                            <div key={inputParams[2].name}>
                              <InputUi
                                label={inputParams[2].label}
                                name={inputParams[2].name}
                                type={inputParams[2].type}
                                LeftIcon={inputParams[2].leftIcon}
                                placeholder={inputParams[2].placeholder}
                                register={_form.register}
                                error={inputParams[2].error}
                                validations={inputParams[2].validations}
                                bg='gray-200'
                                />
                            </div>
                            
                            <div key={inputParams[2].children[state.type === 'new' ? 1 : 0].name}>
                              <InputUi
                                label={inputParams[2].children[state.type === 'new' ? 1 : 0].label}
                                name={inputParams[2].children[state.type === 'new' ? 1 : 0].name}
                                type={inputParams[2].children[state.type === 'new' ? 1 : 0].type}
                                LeftIcon={inputParams[2].children[state.type === 'new' ? 1 : 0].leftIcon}
                                placeholder={inputParams[2].children[state.type === 'new' ? 1 : 0].placeholder}
                                register={_form.register}
                                error={inputParams[2].children[state.type === 'new' ? 1 : 0].error}
                                validations={inputParams[2].children[state.type === 'new' ? 1 : 0].validations}
                                bg='gray-200'
                                />
                            </div>
                          </div>
                        )
                      }
                      {
                        state.type === 'new' &&
                        <div key={inputParams[2].children[0].name}>
                          <InputUi
                            label={inputParams[2].children[0].label}
                            name={inputParams[2].children[0].name}
                            type={inputParams[2].children[0].type}
                            LeftIcon={inputParams[2].children[0].leftIcon}
                            placeholder={inputParams[2].children[0].placeholder}
                            register={_form.register}
                            error={inputParams[2].children[0].error}
                            validations={inputParams[2].children[0].validations}
                            bg='gray-200'
                            />
                        </div>
                      }

                        <div>
                          <ButtonUi isLoading={_userCreate.isLoading || _userUpdate.isLoading}>
                            { state.type === 'new' ? 'Enregistrer' : 'Modifier'}
                          </ButtonUi>
                        </div>
                      </form>
                  }
                </div>
              </Modal.Body>
            </Modal>
          </React.Fragment>
        </div>
      </div>

      {
        _users.isSuccess && _users.data?.data.length !== 0
          ? <TableUi columns={COLUMNS} data={_users.data?.data} colsHidden={["_id", "prenom","email"]} />
          : <p className="text-gray-600 text-sm">Aucun utilisateur trouvé</p>

      }

    </div>
  );
};
